import React from 'react';
import LoginForm from '../../components/LoginForm'
import { withRouter } from "react-router";
import auth from '../../utils/firebase';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            errorMessage: '',
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleEmailChange = (event) => {
        this.setState({
            email: event.target.value,
            errorMessage: ''
        });
    }

    handlePasswordChange = (event) => {
        this.setState({
            password: event.target.value,
            errorMessage: '',
        });
    }

    handleSubmit = async(e) => {
        console.log("Submitting login")
        console.log(this.state.email);
        let hasError = false;
        await auth.signInWithEmailAndPassword(this.state.email, this.state.password).then(response=>{
            console.log("Signed in successfully");
        }).catch(err => {
            hasError = true;
            console.log(err.code + ": ", err.message);
        })
        if(!hasError){
            this.props.history.push('/');
        }
    }

    render() {
        return (
            <div style={styles["login-page-container"]}>
                <img src="https://s3.amazonaws.com/elucd-platform/elucd-logo-blue.svg" style={styles["elucd-logo"]} alt="Elucd logo" />
                <LoginForm 
                    email={this.state.email}
                    password={this.state.password}
                    errorMessage={this.state.errorMessage}
                    handleSubmit={this.handleSubmit}
                    handleEmailChange={this.handleEmailChange}
                    handlePasswordChange={this.handlePasswordChange}
                />
            </div>
        )
    }
}

const styles = {
    "login-page-container": {
        width: 450,
        margin: 'auto',
        display: 'block'
    },
    "elucd-logo": {
        display: 'block',
        width: 160,
        margin: 50,
        textAlign: 'center'
    }
}

const ConnectedLoginPage = withRouter(LoginPage);

export default ConnectedLoginPage;